module.exports = __webpack_public_path__ + "bg-img-2.14928621ee0148921c97.png";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2529011114/src/src/assets/images/bg-img-2.png
// module id = ../../../../../src/assets/images/bg-img-2.png
// module chunks = main